import { Sizes } from 'client/util/Constants';

/**
 * These common props are used by both the DropDownMenu and the DropDownList. They are used in the
 * DropDownMenu because they are passed through to the DropDownList that it renders.
 */
export default {
  props: {
    classNames: {
      default: () => ({}),
      type: Object,
    },
    displayMenuListOnTop: Boolean,
    isLargeDropDown: {
      default: true,
      type: Boolean,
    },
    leftAlignList: {
      default: false,
      type: Boolean,
    },
    bottomAlign: {
      default: false,
      type: Boolean,
    },
    menuFontSize: {
      default: Sizes.small,
      type: String,
      validator: function validator(value) {
        if (value) {
          return typeof Sizes[value] !== 'undefined';
        }
        return true;
      },
    },
    // must be nested arrays to provide multiple filter types
    // [ { menuLabel(optional), menuItems: [ { label, action } ] } ]
    menuSections: {
      required: true,
      type: Array,
    },
    refresh: {
      default: () => {},
      type: Function,
    },
    showMenuLabel: {
      default: false,
      type: Boolean,
    },
    storeModule: {
      default: '',
      type: String,
    },
  },
};
